import {omneticApi} from '@dms/api/base';

import {
  ListEntityChangesApiArg,
  ListEntityChangesApiResponse,
  ListRecordFieldChangesApiArg,
  ListRecordFieldChangesApiResponse,
} from './types';

export const changeLogApi = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    listEntityChanges: build.query<ListEntityChangesApiResponse, ListEntityChangesApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/omnetic/change-log/entity-change/${queryArg.commandId}`,
      }),
    }),
    listRecordFieldChanges: build.query<
      ListRecordFieldChangesApiResponse,
      ListRecordFieldChangesApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/omnetic/change-log/field-change/${queryArg.resourceId}/${queryArg.recordId}`,
        params: {commandId: queryArg.commandId},
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useListEntityChangesQuery,
  useLazyListEntityChangesQuery,
  useListRecordFieldChangesQuery,
  useLazyListRecordFieldChangesQuery,
} = changeLogApi;
